'use strict'
import axios from 'axios'
import store from '@/store'
import Vue from 'vue'

const config = {
  // baseURL: 'https://tangzong.hucs.top/api',
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 60 * 1000,
}
const _axios = axios.create(config)
_axios.interceptors.request.use(
  function (config) {
    // 从store中获取token或从localStorage获取
    const tokenValue = store.state.login.tokenValue || localStorage.getItem('user_tokenValue')
    if (tokenValue) {
      // 使用小写的authorization字段
      config.headers['authorization'] = 'Bearer ' + tokenValue
    }
    return config
  },
  function (error) {
    return Promise.reject(error)
  }
)

_axios.interceptors.response.use(
  async function (response) {
    // 适配RuoYi响应格式
    // RuoYi一般返回格式: { code: 200, msg: "success", data: {} }
    if (response.data.code === 200) {
      return Promise.resolve(response.data)
    } else if (response.data.code === 401) {
      // 未登录或token过期
      Vue.prototype.$clearCache()
      return Promise.reject('请先登录')
    } else if (response.data.code === 500) {
      // 服务器错误
      return Promise.reject(response.data.msg || '服务器错误')
    } else if (response.data.code === 403) {
      // 权限不足
      return Promise.reject('权限不足')
    }
    // 其他错误情况
    return Promise.reject(response.data.msg || '未知错误')
  },
  function (error) {
    // 处理网络错误、超时等
    let errorMessage = '网络错误，请稍后重试'
    if (error.response) {
      switch (error.response.status) {
        case 401:
          errorMessage = '未授权，请重新登录'
          Vue.prototype.$clearCache()
          break
        case 403:
          errorMessage = '拒绝访问'
          break
        case 404:
          errorMessage = '请求错误，未找到资源'
          break
        case 500:
          errorMessage = '服务器错误'
          break
        default:
          errorMessage = `请求错误: ${error.response.status}`
      }
    } else if (error.request) {
      errorMessage = '服务器未响应'
    }
    return Promise.reject(errorMessage)
  }
)

export default _axios
